import React, {useMemo} from "react";
import './articleCard.scss';
import {SimpleStrapiArticle} from "../../../types/BlogTypes";
import Card from "../../../components/ui/card/Card";
import {getLighterImageCloudinary} from "../../../services/utils/cloudinary";
import {Link} from "gatsby";

interface Props {
    article: SimpleStrapiArticle,
}

const ArticleCard = ({
    article,
                     }: Props) => {
    const source = useMemo(() => getLighterImageCloudinary(article?.titleImage, 800, 500), [article?.titleImage]);

    return (
        <Link
            to={`/blog${article.article_path}`}
            className='articleContainer'
            key={article.article_path}
        >
            <Card className='articleCard'>
                <img
                    src={source}
                    alt={article?.title}
                    title={article?.title}
                    className="articleImage"
                />
                <div className='surtitle'>
                    <p className='category'>{article.categories?.[0]?.name}</p>
                    <p>{`· ${article.readtime} min`}</p>
                </div>
                <h3>{article.title}</h3>
            </Card>
        </Link>
    );
};

export default ArticleCard;